import { FetchRequest, FetchResponse } from '@rails/request.js'

export interface Identity {
  id: string
  last_used_at?: string
  name: string
  role: string
}

interface GetAllForUserArgs {
  allAdvisorIdentities?: boolean
  userId: string
}
interface GetCurrentIdentityForUserResponse extends FetchResponse {
  get json(): Promise<{ currentIdentity: string }>
}

interface IdentityListResponse extends FetchResponse {
  get json(): Promise<Identity[]>
}

export function getAllForUser({
  allAdvisorIdentities = false,
  userId,
}: GetAllForUserArgs): Promise<IdentityListResponse> {
  const params = new URLSearchParams({
    all_advisor_identities: allAdvisorIdentities.toString(),
    user_id: userId,
  })
  const endpoint = `/api/identities?${params}`

  return new FetchRequest('get', endpoint).perform()
}

export function getCurrentForUser({ userId }: { userId: string }): Promise<GetCurrentIdentityForUserResponse> {
  const endpoint = `/api/users/${userId}`

  return new FetchRequest('get', endpoint).perform()
}

export function getNavbarIdentities(): Promise<IdentityListResponse> {
  const endpoint = '/identities/navbar_identities'

  return new FetchRequest('get', endpoint).perform()
}
